var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_35562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0844 12.3756C22.5979 13.0472 22.5979 13.954 22.0844 14.6246C20.467 16.736 16.5865 21.0834 12.056 21.0834C7.52546 21.0834 3.64496 16.736 2.02754 14.6246C1.77771 14.303 1.64209 13.9073 1.64209 13.5001C1.64209 13.0928 1.77771 12.6972 2.02754 12.3756C3.64496 10.2642 7.52546 5.91675 12.056 5.91675C16.5865 5.91675 20.467 10.2642 22.0844 12.3756Z",
    stroke: "#959595",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0557 16.75C13.8506 16.75 15.3057 15.2949 15.3057 13.5C15.3057 11.7051 13.8506 10.25 12.0557 10.25C10.2607 10.25 8.80566 11.7051 8.80566 13.5C8.80566 15.2949 10.2607 16.75 12.0557 16.75Z",
    stroke: "#959595",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_35562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.325d1735e68e75b00045c7cea8dfce71.svg";
export { ForwardRef as ReactComponent };